import { useExposedProps } from "zudoku/hooks";
import { parseLocalizedDocsPath } from "../lib/docs-routes";
import { getDocsMessages } from "../lib/localization";

export function useDocsLocalization() {
  const { location } = useExposedProps();
  const { locale, suffix } = parseLocalizedDocsPath(location.pathname);

  return {
    locale,
    messages: getDocsMessages(locale),
    suffix,
  };
}
